import React from 'react';
import { useTranslation } from 'react-i18next';
import './ConfirmWithInitials.scss';

export interface ConfirmWithInitialsProps {
  onConfirm: (e: React.ChangeEvent<HTMLInputElement>) => void;
  text: string;
}

export const ConfirmWithInitials: React.FC<ConfirmWithInitialsProps> = ({ onConfirm, text }) => {
  const { t } = useTranslation();
  const [value, setValue] = React.useState('');

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setValue(val);

    if (val.trim().length > 1) {
      onConfirm(e);
    }
  };

  return (
    <div className="confirm-with-initials">
      <p>
        <label>
          {t(text) || t('Please enter your initials to confirm the change')}:
        </label>
        <input
          type="text"
          name="tested"
          value={value}
          maxLength={3}
          autoFocus={true}
          onChange={onChange}
        />
      </p>
    </div>
  );
};
